<template>
  <nav v-if="router.currentRoute.value.fullPath !== '/'">
    <ul class="hidden text-gray-500 sm:flex">
      <li v-for="(crumb, index) in appStore.breadcrumbs" :key="index" class="flex">
        <RouterLink v-if="crumb.route && crumb.titleProperty === 'Home'" :to="crumb.route">
          <font-awesome-icon
            size="lg"
            class="fatshrink-0 ml-2 cursor-pointer text-gray-500"
            aria-hidden="true"
            :icon="['fal', 'house']"
          />
        </RouterLink>
        <template v-else>
          <p class="px-5 text-xl leading-6 text-gray-300">/</p>
          <router-link
            v-if="crumb.route"
            :to="crumb.route"
            class="font-bold normal-case"
            v-html="crumb.titleProperty"
          ></router-link>
          <div v-else v-html="crumb.titleProperty"></div>
        </template>
      </li>
    </ul>
    <ul class="flex text-gray-500 sm:hidden">
      <li>
        <ButtonComponent
          :text="$t('General_Back')"
          type="transparent"
          class="!px-0"
          :icon="['fal', 'arrow-left']"
          @clicked="goBack()"
        />
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { useAppStore } from '@/stores/portal-stores/general-stores/app'
import { Capacitor } from '@capacitor/core'

const router = useRouter()
const route = useRoute()
const appStore = useAppStore()

const goBack = (): void => {
  // Check if current route is error page, and that the reason is that language is wrong, if yes go to frontpage, since the links parent might not exist.
  if (appStore.nativeLinkIsAnotherLanguage?.isWrongLang === true && route.name === 'NotFound') {
    router.push('/')
    return
  }

  const back = window.history.state.back
  const routeToPush = appStore.breadcrumbs[appStore.breadcrumbs.length - 2].route

  if (back != undefined && Capacitor.isNativePlatform() === false) {
    router.back()
  } else if (Capacitor.isNativePlatform() === true && appStore.isDeeplink === false) {
    router.back()
  } else {
    router.push(routeToPush != undefined ? routeToPush : '/')
    appStore.setIsDeeplink(false)
  }
}
</script>
